import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import { LineStatus } from "../../../constants";
import { getIcon } from "../OrderDetailsTrackerModal";
import { EventState, UnifiedDeliveryEvent } from "../types";

import styles from "./index.module.scss";

interface IProps {
    deliveryDate: string | null;
    trackingNumber: string | null;
    unifiedEvents: UnifiedDeliveryEvent[];
}

export const TrackShipmentDetailsTimeline = (
    props: IProps,
): React.JSX.Element => {
    if (!props.unifiedEvents) {
        return <></>;
    }

    const formatDate = (dateString: string): string => {
        return new Date(dateString).toLocaleString("default", {
            month: "short",
            day: "numeric",
        });
    };

    return (
        <div className={styles.timeline}>
            <ul>
                {props.unifiedEvents.map((event, index) => {
                    const icon = event.icon_code
                        ? getIcon(event.icon_code)
                        : null;

                    const iconClasses = classNames({
                        [styles.stepIconComplete]:
                            event.event_state === EventState.COMPLETE,
                        [styles.stepIconCurrent]:
                            event.event_state === EventState.CURRENT,
                        [styles.stepIcon]:
                            event.event_state === EventState.INCOMPLETE,
                    });
                    const copyClasses = classNames({
                        [styles.stepCopyComplete]:
                            event.event_state === EventState.COMPLETE,
                        [styles.stepCopyCurrent]:
                            event.event_state === EventState.CURRENT,
                        [styles.stepCopy]:
                            event.event_state === EventState.INCOMPLETE,
                    });
                    const dateClasses = classNames({
                        [styles.stepDateComplete]:
                            event.event_state === EventState.COMPLETE,
                        [styles.stepDateCurrent]:
                            event.event_state === EventState.CURRENT,
                        [styles.stepDate]:
                            event.event_state === EventState.INCOMPLETE,
                    });
                    return (
                        <li
                            key={`deliveryStep-${index}`}
                            className={
                                event.event_state === EventState.INCOMPLETE
                                    ? styles.incompleteStep
                                    : styles.step
                            }
                        >
                            {icon && (
                                <SVG
                                    className={iconClasses}
                                    aria-hidden="true"
                                    src={icon}
                                />
                            )}
                            <div className={styles.stepDetails}>
                                <div className={copyClasses}>
                                    <h4>{event.tracking_step_title}</h4>
                                    {(event.event_state ===
                                        EventState.COMPLETE ||
                                        event.event_state ===
                                            EventState.CURRENT) && (
                                        <>
                                            <p>{event.tracking_step_copy}</p>
                                            {event.status ===
                                                LineStatus.SHIPPED &&
                                                props.trackingNumber && (
                                                    <div
                                                        className={
                                                            event.event_state ===
                                                            EventState.CURRENT
                                                                ? styles.stepCopyAddendum
                                                                : styles.stepCopyAddendumComplete
                                                        }
                                                    >
                                                        <span>
                                                            Tracking Number:
                                                        </span>
                                                        {props.trackingNumber}
                                                    </div>
                                                )}
                                            {event.status ===
                                                LineStatus.DELIVERY_SCHEDULED &&
                                                props.deliveryDate && (
                                                    <div
                                                        className={
                                                            event.event_state ===
                                                            EventState.CURRENT
                                                                ? styles.stepCopyAddendum
                                                                : styles.stepCopyAddendumComplete
                                                        }
                                                    >
                                                        <span>
                                                            {t`Delivery Date`}:
                                                        </span>
                                                        {props.deliveryDate}
                                                    </div>
                                                )}
                                        </>
                                    )}
                                </div>
                                <div className={dateClasses}>
                                    {event.date && (
                                        <p>{formatDate(event.date)}</p>
                                    )}
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
